/* eslint-disable @typescript-eslint/no-explicit-any */
import {Box} from '@mui/material';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import React, {Fragment} from 'react';

import {ptBR} from 'date-fns/locale';
import {AlertInfo} from 'presentation/components';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {FlowEnum} from '../../constants';
import {useBookingCalendarDate} from '../../hooks';
import {CustomDay} from './CustomDay';
import {StyledDateCalendar} from './styles';
import {BookingDateCalendarProps} from './types';

const {emptyDaysInMonth} = translations['pt-br'].privateFlow.bookingFlow;

export function BookingDateCalendar({
	availableDates,
	setSelectedDate,
	selectedDate,
	flowType,
}: BookingDateCalendarProps) {
	const {
		beneficiary: {dtCarenciaC, dtCarenciaOdontoC},
	} = useAccountDataStore(state => state.accountData);
	const {
		handleMonthChange,
		highlightedDays,
		isInGracePeriod,
		referenceDate,
		shouldDisableDay,
		maxDate,
		emptyDaysAlert,
	} = useBookingCalendarDate({availableDates});

	const gracePeriod = flowType === FlowEnum.ODONTO ? dtCarenciaOdontoC : dtCarenciaC;

	function handleOnChange(newValue: Date) {
		setSelectedDate(newValue);
	}

	return (
		<Fragment>
			<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
				<StyledDateCalendar
					onMonthChange={(date: Date) => handleMonthChange(date)}
					disablePast
					view="day"
					shouldDisableDate={(day: Date) =>
						shouldDisableDay(day) || isInGracePeriod(gracePeriod, day)
					}
					maxDate={maxDate}
					referenceDate={referenceDate}
					value={selectedDate}
					onChange={(newValue: Date | null) => newValue && handleOnChange(newValue)}
					slots={{
						day: CustomDay as any,
					}}
					slotProps={{
						day: {
							highlightedDays,
						} as any,
					}}
				/>
			</LocalizationProvider>
			{emptyDaysAlert ? (
				<Box mt={-8}>
					<AlertInfo.Root sx={{m: 2}}>
						<AlertInfo.Description>{emptyDaysInMonth}</AlertInfo.Description>
					</AlertInfo.Root>
				</Box>
			) : null}
		</Fragment>
	);
}
